document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-wrap').forEach(wrap => {
    const hotspots = wrap.querySelectorAll('.hotspot');
    const popovers = wrap.querySelectorAll('.popover');

    function closeAll() {
      popovers.forEach(p => p.hidden = true);
      hotspots.forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

function fitPopover(btn, pop) {
  const wrapRect = wrap.getBoundingClientRect();
  const btnRect  = btn.getBoundingClientRect();

  // Zielbreiten
  const pad   = 8;                     // Abstand zum Rand
  const MAX_W = Math.min(320, wrapRect.width - 2*pad);
  const MIN_W = Math.min(240, wrapRect.width - 2*pad);

  // Sichtbar machen, um Maße zu kennen
  pop.style.visibility = 'hidden';
  pop.hidden = false;

  // Wunschbreite (mindestens MIN, höchstens MAX)
  const naturalW = pop.offsetWidth || 280;
  const W = Math.max(MIN_W, Math.min(MAX_W, naturalW));
  pop.style.width = W + 'px';

  // Standard: unterhalb, zentriert
  const centerX = (btnRect.left + btnRect.width/2) - wrapRect.left;
  let leftPx = centerX - W/2;
  let topPx  = (btnRect.bottom - wrapRect.top) + 12; // 12px Abstand nach unten
  let align  = 'center';

  // Wenn links raus: an linke Kante "anlegen"
  if (leftPx < pad) {
    leftPx = pad;
    align = 'left';
  }
  // Wenn rechts raus: an rechte Kante "anlegen"
  if (leftPx + W > wrapRect.width - pad) {
    leftPx = wrapRect.width - W - pad;
    align = 'right';
  }

  // Wenn unten nicht genug Platz: nach OBEN klappen
  const popH = pop.offsetHeight; // nach width-Setzen erneut messen
  const spaceBelow = (wrapRect.bottom - btnRect.bottom);
  if (spaceBelow < popH + 16) {
    topPx = (btnRect.top - wrapRect.top) - popH - 12; // 12px Abstand nach oben
    pop.dataset.placement = 'top';
  } else {
    pop.dataset.placement = 'bottom';
  }

  // Anwenden
  pop.style.left = leftPx + 'px';
  pop.style.top  = topPx + 'px';
  pop.style.transform = 'none';
  pop.style.visibility = 'visible';

  // Klassen für Pfeile/Styling (optional)
  pop.classList.remove('popover--left','popover--right','popover--center');
  pop.classList.add('popover--' + align);
}


    hotspots.forEach(btn => {
      btn.addEventListener('click', () => {
        const pop = wrap.querySelector('#' + btn.getAttribute('aria-controls'));
        const isOpen = !pop.hidden;
        closeAll();
        if (!isOpen) {
          fitPopover(btn, pop);
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    wrap.addEventListener('click', e => {
      if (!e.target.closest('.hotspot') && !e.target.closest('.popover')) {
        closeAll();
      }
    });

    wrap.querySelectorAll('.popover .close').forEach(c => {
      c.addEventListener('click', closeAll);
    });

    // Optional: bei Resize neu clampen, falls Orientierung/Zoom sich ändern
    window.addEventListener('resize', () => {
      const openBtn = wrap.querySelector('.hotspot[aria-expanded="true"]');
      const openPop = wrap.querySelector('.popover:not([hidden])');
      if (openBtn && openPop) fitPopover(openBtn, openPop);
    });
  });
});
